// Firebase Debug Component - Test environment variables
import React, { useEffect, useState } from 'react';
import { app, db, auth } from '../firebase/config';
import { collection, doc, setDoc, deleteDoc } from 'firebase/firestore';

function FirebaseDebug() {
  const [configStatus, setConfigStatus] = useState('Kontrol ediliyor...');
  const [firestoreStatus, setFirestoreStatus] = useState('Kontrol ediliyor...');
  const [detailedError, setDetailedError] = useState(null);

  useEffect(() => {
    async function checkFirebase() {
      // Check if Firebase app is initialized correctly
      try {
        if (app && app.name) {
          setConfigStatus(`Firebase başarıyla yapılandırıldı (${app.name})`);
          console.log("Firebase app:", app);
        } else {
          setConfigStatus('Firebase yapılandırma hatası: app objesi geçersiz');
        }
        
        // Check environment variables
        const envVars = {
          apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
          authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
          projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
          storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
          messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
          appId: process.env.REACT_APP_FIREBASE_APP_ID
        };

        console.log('Environment variables:', envVars);
        
        // Check Firebase project ID explicitly
        if (!process.env.REACT_APP_FIREBASE_PROJECT_ID) {
          throw new Error("Project ID missing from environment variables");
        }
        
        console.log('Firestore object:', db);
        
        // Try to access Firestore using the modular API
        if (db) {
          try {
            // First try to list existing collections
            console.log("Testing Firestore read...");
            const testCollRef = collection(db, 'test');
            const testDocRef = doc(testCollRef, 'test-doc');
            
            console.log("Setting test document...");
            await setDoc(testDocRef, { 
              test: true,
              timestamp: new Date().toISOString() 
            });
            
            console.log("Document written successfully");
            setFirestoreStatus('Firestore bağlantısı başarılı');
            
            // Clean up test document
            await deleteDoc(testDocRef);
            console.log("Test document deleted");
          } catch (firestoreError) {
            console.error('Detailed Firestore error:', firestoreError);
            setFirestoreStatus(`Firestore bağlantı hatası: ${firestoreError.message}`);
            setDetailedError({
              code: firestoreError.code,
              message: firestoreError.message,
              stack: firestoreError.stack
            });
          }
        } else {
          setFirestoreStatus('Firestore başlatılamadı - db objesi yok');
        }
      } catch (error) {
        console.error('Firebase config error:', error);
        setConfigStatus(`Firebase yapılandırma hatası: ${error.message}`);
        setDetailedError({
          message: error.message,
          stack: error.stack
        });
      }
    }
    
    checkFirebase();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>Firebase Hata Ayıklama</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Firebase Yapılandırma Durumu:</h3>
        <p style={{ 
          color: configStatus.includes('başarıyla') ? 'green' : 'red',
          fontWeight: 'bold'
        }}>
          {configStatus}
        </p>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Firestore Bağlantı Durumu:</h3>
        <p style={{ 
          color: firestoreStatus.includes('başarılı') ? 'green' : 'red',
          fontWeight: 'bold'
        }}>
          {firestoreStatus}
        </p>
      </div>
      
      {detailedError && (
        <div style={{ marginBottom: '20px' }}>
          <h3>Hata Detayları:</h3>
          <pre style={{ 
            backgroundColor: '#f8f8f8', 
            padding: '10px', 
            borderRadius: '4px',
            overflow: 'auto'
          }}>
            {JSON.stringify(detailedError, null, 2)}
          </pre>
        </div>
      )}
      
      <div>
        <h3>Ortam Değişkenleri:</h3>
        <pre style={{ 
          backgroundColor: '#f8f8f8', 
          padding: '10px', 
          borderRadius: '4px',
          overflow: 'auto'
        }}>
{`REACT_APP_FIREBASE_API_KEY: ${process.env.REACT_APP_FIREBASE_API_KEY ? '✓' : '✗'}
REACT_APP_FIREBASE_AUTH_DOMAIN: ${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? '✓' : '✗'}
REACT_APP_FIREBASE_PROJECT_ID: ${process.env.REACT_APP_FIREBASE_PROJECT_ID ? '✓' : '✗'}
REACT_APP_FIREBASE_STORAGE_BUCKET: ${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ? '✓' : '✗'}
REACT_APP_FIREBASE_MESSAGING_SENDER_ID: ${process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ? '✓' : '✗'}
REACT_APP_FIREBASE_APP_ID: ${process.env.REACT_APP_FIREBASE_APP_ID ? '✓' : '✗'}`}
        </pre>
      </div>
    </div>
  );
}

export default FirebaseDebug;
